module.exports = __webpack_public_path__ + "static/media/20.4b7a0102.png";